import { useSelector, useDispatch } from 'react-redux';
import { setNotyNewField, setNotyNewMenu, setNotyCount } from 'Actions/NotyActions';
import { useCallback } from 'react';
import { useError } from 'Api/hooks/useError';
import { getNotyCount, getNotyNew, getNotyNewMenu } from 'Api/endpoints/User';

const useNoty = () => {
  const { showErrorPopup } = useError();
  const dispatch = useDispatch();
  const { newField, newMenu, count } = useSelector(state => state.noty);
  const { defaultField } = useSelector(state => state.config);

  const fetchNotyNewField = useCallback(async () => {
    try {
      const result = await getNotyNew();
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return;
      }
      dispatch(setNotyNewField(result.data));
    } catch (e) {
      console.log(e);
    }
  }, [dispatch, showErrorPopup]);

  const fetchNotyNewMenu = useCallback(async () => {
    if (!defaultField) return;
    try {
      const result = await getNotyNewMenu(defaultField._id);
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return;
      }
      dispatch(setNotyNewMenu(result.data));
    } catch (e) {
      console.log(e);
    }
  }, [dispatch, showErrorPopup, defaultField]);

  const fetchNotyCount = useCallback(async () => {
    try {
      const result = await getNotyCount();
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return;
      }
      dispatch(setNotyCount(result.data.count));
    } catch (e) {
      console.log(e);
    }
  }, [dispatch, showErrorPopup]);

  const refreshNoty = useCallback(() => {
    fetchNotyNewMenu();
    fetchNotyCount();
  }, [fetchNotyNewMenu, fetchNotyCount]);

  return { newField, newMenu, count, fetchNotyNewField, fetchNotyNewMenu, fetchNotyCount, refreshNoty };
};

export default useNoty;
